export const SET_USERS = 'setUsers';
export const SET_IS_FETCHED_USERS = 'setIsFetchedUsers';

export default {
    [SET_USERS]({users}, {data, meta}) {
        users.data = data;
        users.meta = meta;
    },
    [SET_IS_FETCHED_USERS](state, fetched) {
        state.fetched = fetched;
    }
}
